import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import {
  Chart,
  Series,
  CommonSeriesSettings,
  SeriesTemplate,
  Title,
  Tooltip,
  Label,
  Format,
  Legend,
  Export,
  ValueAxis,
  ArgumentAxis,
} from "devextreme-react/chart";
import { dataSource, operations } from "./data";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import ErrorMessage from "../../Components/ErrorMessage";
import ActionNotifications from "../../Components/ActionNotifications";
import "./styles.css";

export default function CellReportPage() {
  const date = new Date(),
    [state, setState] = useState({
      showSpinner: false,
      showDateInput: false,
      allCellData: [],
      cells: [],
      projectsList: [],
      searchOptValue: "",
      month: date.toLocaleString("en-US", { month: "long" }),
    });

  useEffect(() => {
    //if (data) {
    setState({ ...state, cells: dataSource });
    //}
  }, []);

  const renderLabReport = () => {
    const customizeSeries = (e) => {
      const gradient = [
        [0, [255, 0, 0]],
        [28, [255, 165, 0]],
        [72, [209, 214, 59]],
        [100, [0, 128, 0]],
      ];
      const percentage = operations.find((x) => x.name === e).percentage * 100;
      let colorRange = [];
      gradient.some((value, index) => {
        if (percentage <= value[0]) {
          colorRange = [index - 1, index];
          return true;
        }
        return false;
      });

      const pickHex = (color1, color2, weight) => {
        const p = weight;
        const w = p * 2 - 1;
        const w1 = (w / 1 + 1) / 2;
        const w2 = 1 - w1;
        const rgb = [
          Math.round(color1[0] * w1 + color2[0] * w2),
          Math.round(color1[1] * w1 + color2[1] * w2),
          Math.round(color1[2] * w1 + color2[2] * w2),
        ];
        return rgb;
      };

      const firstColor = gradient[colorRange[0]][1];
      const secondColor = gradient[colorRange[1]][1];
      const firstColorX = gradient[colorRange[0]][0] / 100;
      const secondColorX = gradient[colorRange[1]][0] / 100 - firstColorX;
      const sliderX = percentage / 100 - firstColorX;
      const ratio = sliderX / secondColorX;
      const result = pickHex(secondColor, firstColor, ratio);
      const firstVal = result[0],
        secVal = result[1],
        thirdVal = result[2];
      return {
        color: `rgb(${firstVal}, ${secVal}, ${thirdVal})`,
        barWidth: "6",
      };
    };

    return (
      <Chart
        id="chart"
        title={{ text: "Operations Breakdown", font: { color: "#FFFFFF" } }}
        dataSource={operations}
        rotated={true}
      >
        <CommonSeriesSettings
          argumentField="name"
          valueField="percentage"
          type="bar"
          color="#FFFFFF"
        ></CommonSeriesSettings>
        <SeriesTemplate nameField="name" customizeSeries={customizeSeries} />

        <ValueAxis
          name="individual"
          pane="bottomPane"
          label={{ format: "percent", font: { color: "#FFFFFF" } }}
          grid={{ color: "#444" }}
        />
        <ArgumentAxis
          label={{ font: { color: "#FFFFFF" } }} // X-axis labels (your categories)
        />
        <Tooltip
          enabled={true}
          format="percent"
          color="#333"
          font={{ color: "#FFF" }}
        />
        <Legend visible={false} />
      </Chart>
    );
  };

  return (
    <div className="px-lg-4 content">
      <div className="px-3 page-content">
        {/* <div className="row my-md-4">
          <h1 className="white">Cell Hours Report</h1>
        </div> */}
        <div className="container-fluid g-0">
          <div className="row">
            <div className="col-12">
              <div className="contentBox p-5 my-md-4">
                <h1 className="white">Cell Hours Report</h1>
                {renderLabReport()}
              </div>
            </div>
          </div>
          <div id="filler" />
        </div>
      </div>
    </div>
  );
}
